/**
 *  @module Resources/Cancels
 */
import { __assign, __extends } from "tslib";
import { CRUDResource } from "./CRUDResource.js";
export var CancelStatus;
(function (CancelStatus) {
    CancelStatus["PENDING"] = "pending";
    CancelStatus["SUCCESSFUL"] = "successful";
    CancelStatus["FAILED"] = "failed";
    CancelStatus["ERROR"] = "error";
})(CancelStatus || (CancelStatus = {}));
var Cancels = /** @class */ (function (_super) {
    __extends(Cancels, _super);
    function Cancels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cancels.prototype.list = function (storeId, chargeId, data, auth, callback) {
        return this._listRoute()(data, callback, auth, { storeId: storeId, chargeId: chargeId });
    };
    Cancels.prototype.create = function (storeId, chargeId, data, auth, callback) {
        return this._createRoute(Cancels.requiredParams)(data, callback, auth, { storeId: storeId, chargeId: chargeId });
    };
    Cancels.prototype.get = function (storeId, chargeId, id, data, auth, callback) {
        return this._getRoute()(data, callback, auth, { storeId: storeId, chargeId: chargeId, id: id });
    };
    Cancels.prototype.poll = function (storeId, chargeId, id, data, auth, callback, 
    /**
     * Condition to cancel the polling and return `null`,
     */
    cancelCondition, successCondition, iterationCallback) {
        var _this = this;
        if (successCondition === void 0) { successCondition = function (_a) {
            var status = _a.status;
            return status !== CancelStatus.PENDING;
        }; }
        var pollingData = __assign(__assign({}, data), { polling: true });
        var promise = function () { return _this.get(storeId, chargeId, id, pollingData, auth); };
        return this.api.longPolling(promise, successCondition, cancelCondition, callback, undefined, undefined, iterationCallback);
    };
    Cancels.requiredParams = [];
    Cancels.routeBase = "/stores/:storeId/charges/:chargeId/cancels";
    return Cancels;
}(CRUDResource));
export { Cancels };
//# sourceMappingURL=Cancels.js.map